var defaultCollection = {
  '@type': '@builder.io/sdk:Element',
  '@version': 2,
  component: {
    name: '_Collection_',
    options: {
      showBlockPositions: false,
      carouselOptions: {
        arrows: true,
        dots: false,
        autoplay: false,
        arrowsOffset: null
      },
      sortList: '',
      isCarousel: true,
      gridOptions: {
        sideNav: {
          showHeader: true
        }
      },
      productSettings: {
        label: 'The tried & true must-haves.',
        header: 'Recommended for you'
      }
    }
  },
  responsiveStyles: {
    large: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      flexShrink: '0',
      boxSizing: 'border-box',
      marginTop: '0px'
    }
  }
};
var SXFTabsBuilderComponent = {
  name: '_Tabs_',
  canHaveChildren: true,
  defaultStyles: {
    marginTop: '0px',
    width: '100%',
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '16px'
  },
  inputs: [{
    name: 'tabs',
    type: 'list',
    subFields: [{
      name: 'content',
      type: 'uiBlocks',
      defaultValue: []
    }, {
      name: 'label',
      type: 'string'
    }],
    defaultValue: [{
      content: [defaultCollection],
      label: 'Title'
    }]
  }, {
    name: 'showArrowsOnMobile',
    type: 'boolean',
    defaultValue: false
  }]
};
export default SXFTabsBuilderComponent;